import { useEffect, useRef } from 'react';

import { useReferrer as useReferrerQuery } from 'modules/referralProgram/hooks/useReferrer';

export const useReferrer = () => {
  const { data: referrer, isLoading, startedTimeStamp } = useReferrerQuery();

  const ref = useRef(startedTimeStamp);

  const isLoaded = typeof referrer !== 'undefined';

  useEffect(() => {
    if (isLoaded) {
      ref.current = startedTimeStamp;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded]);

  const isLoadedForTheFirstTime = startedTimeStamp === ref.current;

  const hasReferrer = !isLoadedForTheFirstTime && Boolean(referrer);

  return { hasReferrer, isLoaded, isLoading };
};
